/* import __COLOCATED_TEMPLATE__ from './request-background.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './request-background.module.scss';

@classic
@classNames(styles.component)
export default class RequestRequestBackground extends Component {}
